import type { Observable } from 'rxjs';
import type { CrmContact } from '@integrations/crm-contacts/contracts/crm-contact.contract';

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CRM_SERVICE_API_BASE } from '@integrations/crm-pipelines';
import { parseResponse } from '@integrations/shared/parse-response';
import { CrmContactCollectionResponseSchema } from '@integrations/crm-contacts/contracts/crm-contact.contract';

@Injectable({ providedIn: 'root' })
export class CrmContactsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(CRM_SERVICE_API_BASE);

    public getContactAttributes(): Observable<CrmContact[]> {
        return this.http.get<unknown>(`${this.baseUrl}/contacts/attributes`).pipe(
            map(
                (res) =>
                    parseResponse(res, CrmContactCollectionResponseSchema, {
                        endpoint: 'crm/contacts/attributes',
                        method: 'GET',
                    }).data
            )
        );
    }
}
